<template>
	<v-layout row wrap>
		<v-flex xs12 ma-2>
			<v-menu
					:close-on-content-click="false"
					:nudge-right="40"
					full-width
					lazy
					min-width="290px"
					offset-y
					transition="scale-transition"
					v-model="menu"
					:disabled="readonly"
			>
				<template #activator="{ on }">
					<v-text-field
							:clearable="isClearable"
							:label="dateLabel"
							:placeholder="' '"
							:error-messages="$props.error"
							readonly
							v-model="valueFormatted"
							v-on="on"
							v-if="!isSimple"
					></v-text-field>
					<v-text-field
							:clearable="isClearable"
							:placeholder="' '"
							readonly
							v-model="valueFormatted"
							v-on="on"
							class="simple"
							hide-details
							v-if="isSimple"
					></v-text-field>
				</template>
				<v-date-picker :first-day-of-week="1" :locale="'hr'" :readonly="readonly" @input="menu = false" v-model="selectedValue"></v-date-picker>
			</v-menu>
		</v-flex>
	</v-layout>
</template>

<script>
	export default {
		name: "DatePicker",
		props: ['readonly', 'value', 'dateLabel', 'error', 'simple', 'clearable'],
		data() {
			return {
				menu: false,
				valueFormatted: null,
				selectedValue: this.$props.value
			}
		},
		computed: {
			isSimple() {
				return (typeof this.$props.simple !== 'undefined');
			},
			isClearable() {
				return (typeof this.$props.clearable !== 'undefined');
			}
		},
		watch: {
			value: function (newVal, oldVal) {
				if (newVal != oldVal) {
					if (newVal != null) {
						if (this.selectedValue != null) {
							if (this.selectedValue.value != newVal) {
								this.setValue(newVal);
							}
						} else {
							this.setValue(newVal);
						}
					} else {
						this.selectedValue = null;
					}
				}
			},
			selectedValue: function (val) {
				this.valueFormatted = this.formatDate(this.selectedValue);
				if (val != null) {
					if (val != this.$props.value) {
						this.$nextTick(() => {
							this.$emit('input', val);
						})
					}
				} else {
					this.$nextTick(() => {
						this.$emit('input', null);
					})
				}
				this.$nextTick(() => {
					this.$emit('changes', null);
				})
			},
			valueFormatted: function(val) {
				if (val == null) {
					this.selectedValue = null;
				}
			}
		},
		methods: {
			parseDate(date) {
				if (!date) return null
				const [month, day, year] = date.split('.')
				return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
			},
			formatDate(date) {
				if (!date) return null
				const [year, month, day] = date.split('-')
				return `${parseInt(day)}.${parseInt(month)}.${year}.`
			},
			setValue(newVal) {
				this.selectedValue = newVal;
			}
		},
		mounted() {
			this.setValue(this.$props.value);
			this.valueFormatted = this.formatDate(this.selectedValue);
		}
	}
</script>

<style scoped>
	.simple {
		padding: 0px;
		margin: 0px;
	}
</style>
